import React from 'react';
import { BookOpenIcon, CpuIcon, FactoryIcon, GitBranchIcon, RadarIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  book: BookOpenIcon,
  cpu: CpuIcon,
  logic: GitBranchIcon,
  sensor: RadarIcon,
  wrench: WrenchIcon,
  factory: FactoryIcon
};
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-white" data-id="element-156" data-mp="12868167h8ux">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-157" data-mp="3t7luro8svoiy">
        <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.16em] text-brand-blue" data-id="element-158" data-mp="auxi2x5o4oqs">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1 font-display text-xl uppercase leading-tight text-brand-carbon sm:text-3xl" data-id="element-159" data-mp="kslb9inmlo6u">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-1.5 text-[0.75rem] font-extrabold uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-160" data-mp="36bdywv24irt6">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-brand-muted" data-id="element-161" data-mp="3bbtabh2uhp8i">
          No es simplemente otro ebook técnico. Es una ruta de aprendizaje que
          organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo se conecta cada componente
          de un sistema automatizado.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-162" data-mp="3u706glyejnoq">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-brand-steel bg-white p-3 text-left shadow-[0_2px_0_0_var(--brand-steel)]" data-id="element-163" data-mp="6w0gfa5rnv9l" data-mpi={i}>
                <span className="inline-flex w-fit items-center gap-1.5 rounded bg-brand-blue px-2 py-0.5 text-[0.6rem] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-164" data-mp="2cwt3dhyb3n2u">
                  <Icon size={11} className="text-brand-yellow" data-id="element-165" data-mp="27vn93fozzrr7" />
                  Tomo {i + 1}
                </span>
                <h3 className="mt-1.5 text-[0.82rem] font-extrabold uppercase leading-tight text-brand-navy" data-id="element-166" data-mp="2hvw9z6txq1cx">
                  {tomo.title}
                </h3>
                <p className="mt-1 text-[0.78rem] leading-snug text-brand-muted" data-id="element-167" data-mp="2vlpzlrd9kpnp">
                  {tomo.desc}
                </p>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-168" data-mp="35k5snzvuq8zu">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}